import { appCode } from '../common/consts';
// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const aboutComponent = r => require.ensure([], () => r(require('@/views/About')), 'About');
const OnboardingPage = r => require.ensure([], () => r(require('@/views/gbm/onboarding/Index')), 'GBM Onboarding');
const TermsPage = r => require.ensure([], () => r(require('@/views/gbm/onboarding/Terms')), 'GBM Terms Page');
const LoginPage = r => require.ensure([], () => r(require('@/views/gbm/onboarding/Login')), 'GBM Login Page');
const SelectBrand = r => require.ensure([], () => r(require('@/views/gbm/onboarding/SelectBrand')), 'GBM-SelectBrand');
const SkillRouting = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/SkillRouting')), 'GBM-SkillRouting');
const ConversationalSettings = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/ConversationalSettings')), 'GBM-ConversationalSettings');
const AgentInteractions = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/AgentInteractions')), 'GBM-AgentInteractions');
const NonLocalEntryPoint = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/NonLocalEntryPoint')), 'GBM-NonLocalEntryPoint');
const UrlEntryPoint = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/UrlEntryPoint')), 'GBM-UrlEntryPoint');
const LocationEntryPoints = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/LocationEntryPoints')), 'GBM-LocationEntryPoints');
const TestLinks = r => require.ensure([], () => r(require('@/views/gbm/onboarding/TestLinks')), 'GBM-TestLinks');
const VerifyConnector = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/VerifyConnector')), 'GBM-VerifyConnector');
const LaunchConnector = r =>
  require.ensure([], () => r(require('@/views/gbm/onboarding/LaunchConnector')), 'GBM-LaunchConnector');
const LandingPage = r => require.ensure([], () => r(require('@/views/gbm/LandingPage')), 'Landing Page');

const routes = [
  {
    path: `/${appCode}/about`,
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: aboutComponent,
    components: { [appCode]: aboutComponent },
  },
  {
    path: `/${appCode}/gbm`,
    name: 'GBM Landing Page',
    components: { [appCode]: LandingPage },
  },
  {
    path: `/${appCode}/gbm/onboard`,
    name: 'GBM-Onboard',
    components: { [appCode]: OnboardingPage },
    children: [
      {
        path: 'terms',
        name: 'Terms Page',
        component: TermsPage,
      },
      {
        path: 'google-login',
        name: 'Login Page',
        component: LoginPage,
      },
      {
        path: 'connectors/:connectorId/businesses',
        name: 'Google SelectBrand',
        component: SelectBrand,
      },
      {
        path: 'connectors/:connectorId/skills',
        name: 'Skill Routing',
        component: SkillRouting,
      },
      {
        path: 'connectors/:connectorId/conversational-settings',
        name: 'Conversational Settings',
        component: ConversationalSettings,
      },
      {
        path: 'connectors/:connectorId/agent-availibility',
        name: 'Agent Interactions',
        component: AgentInteractions,
      },
      {
        path: 'connectors/:connectorId/non-local-entry-points',
        name: 'Non-Local Entry Points',
        component: NonLocalEntryPoint,
      },
      {
        path: 'connectors/:connectorId/url-entry-points',
        name: 'URL Entry Points',
        component: UrlEntryPoint,
      },
      {
        path: 'connectors/:connectorId/location-entry-points',
        name: 'Location Entry Points',
        component: LocationEntryPoints,
      },
      {
        path: 'connectors/:connectorId/test-links',
        name: 'Test Links',
        component: TestLinks,
      },
      {
        path: 'connectors/:connectorId/verify',
        name: 'Verify Connector',
        component: VerifyConnector,
      },
      {
        path: 'connectors/:connectorId/launch',
        name: 'Launch Connector',
        component: LaunchConnector,
      },
    ],
  },
];

export default routes;
